import React from "react";
import { Reveal, PageHero, CTASection } from "../components/common";
import Seo from "../components/Seo";
import { Button } from "../components/ui/button";
import { heroImages } from "../data/mock";
import { Star, ExternalLink, ShieldCheck, Clock, Anchor } from "lucide-react";

const FISHINGBOOKER = "https://fishingbooker.com/charters/view/11081?utm_source=share_charter&utm_medium=copy_link";

const Trust = ({ icon: Icon, title, text }) => (
  <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
    <Icon className="h-5 w-5 text-[#f5a524] mb-2" />
    <p className="text-white font-heading text-sm">{title}</p>
    <p className="text-slate-400 text-xs mt-1">{text}</p>
  </div>
);

const Book = () => (
  <>
    <Seo
      title="Book Hog Tide Fishing — San Juan del Sur Charters on FishingBooker"
      description="Reserve your San Juan del Sur fishing charter with Hog Tide Fishing. Book securely on FishingBooker with instant confirmation and verified reviews, or message us on WhatsApp."
      path="/book"
      image={heroImages[1].img}
    />
    <PageHero
      image={heroImages[1].img}
      eyebrow="Book Your Charter"
      title="Reserve Your San Juan del Sur Adventure"
      sub="Lock in your private Hog Tide fishing charter — book securely through FishingBooker or reach us directly."
    />
    <section className="bg-[#0a1f33] py-16">
      <div className="container-x max-w-3xl">
        <Reveal>
          <div className="rounded-3xl border border-white/10 bg-[#0e2740] p-8 md:p-10 text-center">
            <div className="flex items-center justify-center gap-1 text-[#f5a524] mb-3">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-[#f5a524]" />)}
            </div>
            <h2 className="font-display text-3xl text-white">Book Hog Tide Fishing on FishingBooker</h2>
            <p className="text-slate-300 mt-3">
              Prefer to book through a trusted marketplace? Reserve your San Juan del Sur charter with instant
              confirmation, secure payment and verified angler reviews on FishingBooker.
            </p>
            <a href={FISHINGBOOKER} target="_blank" rel="noreferrer" data-testid="fishingbooker-cta">
              <Button className="btn-gold h-12 px-8 mt-6 gap-2">View &amp; Book on FishingBooker <ExternalLink className="h-4 w-4" /></Button>
            </a>
            <div className="grid sm:grid-cols-3 gap-4 mt-8">
              <Trust icon={ShieldCheck} title="Secure & Verified" text="Protected booking with real reviews from anglers." />
              <Trust icon={Clock} title="Instant Confirmation" text="Pick your date and lock the boat in minutes." />
              <Trust icon={Anchor} title="Private Charter" text="The whole boat is yours — up to 12 guests." />
            </div>
          </div>

          <div className="mt-10 text-slate-300 space-y-4 text-sm leading-relaxed">
            <h3 className="font-display text-2xl text-white">Why book a Hog Tide charter in San Juan del Sur?</h3>
            <p>
              Hog Tide Fishing runs private sport-fishing charters out of San Juan del Sur, Nicaragua — one of the
              Pacific's most productive and least-crowded fisheries. From trophy sailfish, blue and black marlin,
              yellowfin tuna and mahi-mahi offshore, to roosterfish, cubera snapper, grouper and red snapper on our
              inshore and bottom-fishing trips, there's world-class action year-round.
            </p>
            <p>
              Every charter is fully private and includes a professional local crew, all rods, reels, tackle and bait,
              fishing licenses, ice and bottled water, plus fresh sashimi prepared right on the boat. Booking through
              FishingBooker gives you secure payment, instant confirmation and the peace of mind of verified reviews —
              or you can message us directly on WhatsApp to plan a custom trip.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
    <CTASection image={heroImages[2].img} />
  </>
);

export default Book;
